@if (data) {
  <ul class="list-disc text-black pl-5">
    @for (cell of data.all_design_cells; track cell) {
      <li class="text-gray-800">{{ cell.study_arm_uid }} × {{ cell.study_epoch_uid }} → {{ cell.study_element_uid }}</li>
    }
  </ul>
}
